export default __webpack_public_path__ + "static/media/logo2.3d3b5a51.svg";